import { render } from "./popup.vue?vue&type=template&id=7e9c0cd4"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=7e9c0cd4&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__